"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDialogClickOutside = void 0;
const react_1 = require("react");
/**
 * 處理對話框背景點擊關閉的 hook
 * 使用 onMouseDown 而非 onClick，防止在視窗內點擊拖動到視窗外時誤觸關閉
 * 只有在滑鼠按下時的目標是背景元素本身時才關閉對話框
 *
 * @param onClose 關閉對話框的函數
 * @returns handleBackgroundMouseDown 處理背景滑鼠按下的函數
 *
 * @example
 * ```tsx
 * const handleBackgroundMouseDown = useDialogClickOutside(() => setIsOpen(false));
 *
 * return (
 *   <div className="fixed inset-0 bg-black/50" onMouseDown={handleBackgroundMouseDown}>
 *     <div className="modal-content">...</div>
 *   </div>
 * );
 * ```
 */
const useDialogClickOutside = (onClose) => {
    const handleBackgroundMouseDown = (0, react_1.useCallback)((e) => {
        // 只有在背景元素本身上按下滑鼠時才關閉
        if (e.target === e.currentTarget) {
            onClose();
        }
    }, [onClose]);
    return handleBackgroundMouseDown;
};
exports.useDialogClickOutside = useDialogClickOutside;
exports.default = exports.useDialogClickOutside;
